// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-4686fdc4],\n.fade-leave-active[data-v-4686fdc4] {\n  -webkit-transition: opacity 0s;\n  transition: opacity 0s;\n}\n.fade-enter[data-v-4686fdc4],\n.fade-leave-to[data-v-4686fdc4] {\n  opacity: 0;\n}\n.c-main[data-v-4686fdc4],.c-contents[data-v-4686fdc4] {\n  padding:0px;\n}\n", ""]);
// Exports
module.exports = exports;
